import { render, staticRenderFns } from "./schoolcontentTwo.vue?vue&type=template&id=d1d0007c&scoped=true"
import script from "./schoolcontentTwo.vue?vue&type=script&lang=js"
export * from "./schoolcontentTwo.vue?vue&type=script&lang=js"
import style0 from "./schoolcontentTwo.vue?vue&type=style&index=0&id=d1d0007c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d0007c",
  null
  
)

export default component.exports